<template>
<div class="found-body">
  <!-- <div style="filter: blur(4px)">
    <div class="top-found"></div>
    <div class="top-found-benner"></div>
    <div class="tabs-found">
      <div class="tab-found" v-for="item in 4">
      <div class="box"></div>
      </div>
    </div>
    <div class="white-border">
      <van-skeleton title :row="4" />
    </div>
    <div class="top-found-benner"></div>
    <div class="top-found-benner"></div>
  </div> -->

  <!-- <div class="fixed-todo">
    <div class="found-404">
      <van-empty description="加载中..." />
      <van-button round type="danger" color="#E63241" @click="finish" class="bottom-button">返回首页</van-button>
    </div>
  </div> -->

  <!-- <div class="not-found">
    <div class="found-404">
      <van-empty description="加载中..." />
    </div>
    <van-skeleton title :row="3" />
    <van-button round type="danger" @click="finish" class="bottom-button">返回首页</van-button>
  </div> -->
</div>
</template>

<script>
export default {
  methods: {
    finish(){
      window.location.replace(window.location.origin);
    }
  },
};  
</script>

<style lang="less" scoped>
@media(max-width: 1100px){
  .found-body {
  font-size: 18px;
  --proportion: 0.57;
}
}

/*>=1100的设备*/
@media(min-width: 1100px){

  .found-body {
  font-size: 22px;
  --proportion: 0.57;
}
}

/*>=1280的设备*/
@media (min-width: 1280px){

  .found-body {
  font-size: 22px;
  --proportion: 0.67;
}
}
@media (min-width: 1380px){

  .found-body {
  font-size: 24px;
  --proportion: 0.71;
}
}

@media (min-width: 1440px) {

  .found-body {
  font-size: 25px;
  --proportion: 0.75;
}
}
@media (min-width: 1600px) {

  .found-body {
  font-size: 25px;
  --proportion: 0.83;
}
}

@media (min-width: 1680px){

  .found-body {
  font-size: 28px;
  --proportion: 0.875;
}
}
@media (min-width: 1900px){
  .found-body{
  font-size: 33px;
  --proportion: 1;
}
}

  .found-body{
    position: relative;
    width: 100%;
    height: 100vh;
    background-color: #100f0f;
    *{
      border-radius: 10px;
    }
  }
  .top-found{
    margin: 0px auto;
    width: 86%;
    height: calc(var(--proportion) * 48px);
    background: #000;
    border-bottom: 1px solid #333;
  }
  .top-found-benner{
    margin: 0px auto;
    margin-top: calc(var(--proportion) * 48px);
    background-color: #252729;
    width: 86%;
    height: calc(var(--proportion) * 200px);
  }
  .not-found{
    margin: 0px auto;
    padding-top: calc(var(--proportion) * 100px) ;
    width: 50%;
    height: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .found-404{
    position: absolute;
    top: 15%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-weight: 600;
    font-size: 90px;
    color: #999;
  }
  .todo{
    line-height: 20px;
    font-size: 14px;
    margin-top: 40px;
    display: flex;
    justify-content: center;
    color: #999;
  }
  ::v-deep{
      .van-count-down{
        color: #999 !important;
      }
    }
    .bottom-button {
    margin: 10px auto;
    margin-top: calc(var(--proportion) * 400px);
    width: 160px;
    height: 40px;
  }


  .tabs-found{
    margin: 40px auto;
    width: 86%;
    display: flex;
    justify-content: space-between;

    .tab-found {
      position: relative;
      width: 20%;
      max-width: calc(var(--proportion) * 200px) ;
      height: calc(var(--proportion) * 180px);
      background-color: #000;
      .box{
        margin: calc(var(--proportion) * 20px) ;
        width: 60%;
        height: calc(var(--proportion) * 30px) ;
        background-color: #252729;
      }
      ::after{
        position: absolute;
        left: 6px;
        bottom: calc(var(--proportion) * 20px) ;
        content:'';
        width: 80%;
        height: calc(var(--proportion) * 10px);
        background-color: #252729;
      }
    }
  }
  .white-border{
    margin: 0px auto;
    margin-top: calc(var(--proportion) * 60px) ;
    padding-top: calc(var(--proportion) * 20px) ;
    width:86%;
    height: calc(var(--proportion) * 300px);
    background-color: #fff;
  }
  .fixed-todo{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,0.3);
    z-index: 10;
  }
</style>